module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-l-50 m-t-0 w-1200",
    staticStyle: {
      "color": "#000"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "50px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-400",
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('el-input', {
    staticClass: "h-40 w-400",
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.form.list), function(item, index) {
    return _c('el-form-item', {
      attrs: {
        "label": ""
      }
    }, [_c('div', {
      staticClass: "m-l-10 fl w-280"
    }, [_vm._v("\n          步骤" + _vm._s(index + 1) + "、名称："), _c('el-input', {
      staticClass: "h-40 w-150 m-r-30",
      attrs: {
        "value": item.buzhou
      },
      model: {
        value: (item.buzhou),
        callback: function($$v) {
          _vm.$set(item, "buzhou", (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "item.buzhou"
      }
    }), _vm._v("\n          图片：\n        ")], 1), _vm._v(" "), _c('div', {
      staticClass: "m-l-10 fl w-800"
    }, [_c('img', {
      staticClass: "fl m-r-10",
      staticStyle: {
        "width": "285px",
        "height": "160px",
        "cursor": "pointer",
        "background-color": "#aaa"
      },
      attrs: {
        "src": item.content
      },
      on: {
        "click": function($event) {
          return _vm.handlePictureCardPreview(item.content)
        }
      }
    }), _vm._v(" "), _c('el-upload', {
      staticClass: "fl",
      attrs: {
        "action": _vm.uploadUrl,
        "type": "drag",
        "thumbnail-mode": true,
        "on-success": function (response, file, fileList) {
          return _vm.uploadSuccess(response, file, fileList, item)
        },
        "show-file-list": false
      }
    }, [_c('i', {
      staticClass: "el-icon-upload"
    }), _vm._v(" "), _c('div', {
      staticClass: "el-dragger__text",
      on: {
        "click": function($event) {
          return _vm.set_upload(index)
        }
      }
    }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")]), _vm._v("  jpg/png文件")])]), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "margin-top": "63px",
        "margin-left": "10px"
      },
      attrs: {
        "size": "small",
        "type": "danger",
        "plain": ""
      },
      on: {
        "click": function($event) {
          return _vm.configDel(index, _vm.form.list)
        }
      }
    }, [_vm._v("删除步骤")])], 1)])
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "m-l-50",
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.configAdd(_vm.form.list)
      }
    }
  }, [_vm._v("增加步骤")]), _vm._v(" "), _c('p', {
    staticClass: "m-l-50"
  }, [(_vm.form.list.length > 0) ? _c('span', {
    staticStyle: {
      "color": "#f00"
    }
  }, [_vm._v("备注：修改完成后请点击下方的保存，否则修改无效")]) : _vm._e()])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("返 回")])], 1)], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    staticStyle: {
      "background-color": "#aaa"
    },
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-73d3b678!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Files/guide/edit.vue
// module id = 1858
// module chunks = 2